module.exports = __webpack_public_path__ + "media/images/mailer/message-48-white-02bb0b3575d57460e2004ba912f0f8ad.png";